export enum RouteName {
  SavedItems = "savedItems",
  Collector = "collector",
  Homepage = "homepage",
  LandingPageCategory = "landingPageCategory",
  PublicItemDetail = "publicItemCard",
  About = "about",
  Contacts = "contacts",
  Collectors = "collectors",

  /**
   * ==============================================
   * Messages
   * ==============================================
   */

  Messages = "messages",
  MessagesEmailNotificationsUnsubscribed = "messagesUnsubscribedSuccess",
  MessagesEmailNotificationsUnsubscribeError = "messagesUnsubscribeError",

  /**
   * ==============================================
   * Collectibles (database/catalogue)
   * ==============================================
   */

  Catalogue = "catalogueStart",
  CatalogueItem = "catalogueItem",
  CatalogueCategory = "catalogueCategory",

  /**
   * ==============================================
   * Auth
   * ==============================================
   */

  Registration = "registrationNew",
  RegistrationEmailVerified = "registrationEmailVerified",
  FacebookSsoCallback = "facebookSsoCallback",
  Login = "login",
  PasswordRestore = "forgottenPassword",
  PasswordRestoreProcessing = "forgottenPasswordProcessing",

  /**
   * ==============================================
   * Magazine
   * ==============================================
   */

  Magazine = "articlesList",
  Article = "article",
  ArticleDraft = "articleDraft",

  /**
   * ==============================================
   * Collection
   * ==============================================
   */

  CollectionItemNew = "collectionItemNew",
  Collection = "collection",
  MyItemDetail = "myCollectionItemDetail",

  /**
   * ==============================================
   * AI identification
   * ==============================================
   */

  AiForm = "aiForm",
  AiFormWithPreselectedCategory = "aiFormWithPreselectedCategory",
  AiDetail = "aiDetail",
  AiHistory = "aiHistory",

  /**
   * ==============================================
   * Account
   * ==============================================
   */

  AccountSetup = "accountSetup",
  AccountSettings = "accountSettings",
  YearInReview = "yearInReview",

  /**
   * ==============================================
   * Marketplace
   * ==============================================
   */

  Marketplace = "marketplace",
  ShoppingCart = "shoppingCart",
  MarketplaceOrder = "marketplaceOrder",
  MarketplaceOrderSuccess = "marketplaceOrderSuccess",
  MarketplaceOrderFail = "marketplaceOrderFail",
  MarketplaceItem = "marketplaceItem",
  MarketplaceItemCreated = "marketplaceItemCreated",
  Sales = "saleList",
  Sale = "saleDetail",
  Purchases = "purchaseList",
  Purchase = "purchaseDetail",

  /**
   * ==============================================
   * Legals
   * ==============================================
   */

  Gdpr = "gdpr",
  Tac = "tac",
  Guide = "guide",

  /**
   * ==============================================
   * Comic-con
   * ==============================================
   */

  ComicCon = "comicCon",
  ComicConTerms = "comicConTerms",

  /**
   * ==============================================
   * Others
   * ==============================================
   */

  Error404 = "error404",
  Support = "support",
}
